export const notification_unread_count = `subscription notification_unread_count{
    notification_unread_count
}`;
